import { NgModule } from '@angular/core';
import { PrizmIconsSvgComponent } from './prizm-icons.component';

@NgModule({
  declarations: [PrizmIconsSvgComponent],
  exports: [PrizmIconsSvgComponent],
})
export class PrizmIconsSvgModule {}
